import Tooltip from '@mui/material/Tooltip';
import colorConvert from 'color-convert';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { NetworkUser } from '../../../../../interfaces/interfaces';
import { RootState } from '../../../../../reduxToolkit/store';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { imageKitLoader } from '../../../../../services/helper';

interface UserSlotProps {
  user?: NetworkUser;
  isRoomHost?: boolean;
}

const UserSlot = ({ user, isRoomHost }: UserSlotProps) => {
  const [color, setColor] = useState([216, 97, 34]);
  const eventColor = useSelector(({ common }: RootState) => common.event?.template.mainColor);

  useEffect(() => {
    if (eventColor) {
      const [h, s] = colorConvert.hex.hsl(eventColor);
      const randomToHundred = Math.floor(Math.random() * 50) + 30;
      setColor([h, s, randomToHundred]);
    }
  }, [eventColor]);

  const hslColor = `hsl(${color[0]}, ${color[1]}%, ${color[2]}%)`;

  if (!user) return <div style={{ backgroundColor: '#cfcfcf' }} className="w-16 h-16 rounded-md templateBorder" />;
  if (!user.avatar)
    return (
      <Tooltip placement="top" title={(isRoomHost ? '[HOST] ' : '') + user.name}>
        <div
          style={{ backgroundColor: hslColor, ...(isRoomHost ? { borderColor: eventColor, borderWidth: '1px', borderStyle: 'solid' } : {}) }}
          className="w-16 h-16 rounded-md text-white text-3xl grid place-items-center">
          {user.name?.length > 0 ? user.name[0] : ''}
        </div>
      </Tooltip>
    );
  return (
    <Tooltip placement="top" title={isRoomHost ? `[HOST] ${user.name}` : `${user.name}`}>
      <div style={{ ...(isRoomHost ? { borderColor: eventColor, borderStyle: 'solid' } : {}) }}>
        <Image
          loader={imageKitLoader}
          objectFit="cover"
          src={user.avatar}
          className={`rounded-md bg-cover w-16 h-16`}
          alt="user avatar"
          width={256}
          height={256}
        />
      </div>
    </Tooltip>
  );
};

export default UserSlot;
